import { Component } from '@theme/component';

/** Inline, keyboard-accessible Shopify predictive product search. */
class TimberLiveSearch extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.input = this.querySelector('input[type="search"]');
    this.results = this.querySelector('[data-results]');
    this.abort = new AbortController();
    const { signal } = this.abort;
    this.input.addEventListener('input', () => {
      clearTimeout(this.timer);
      this.request?.abort();
      this.timer = setTimeout(() => this.search(), 220);
    }, { signal });
    this.addEventListener('keydown', e => {
      if (e.key === 'Escape') this.close();
      if (e.key === 'ArrowDown') {
        const links = [...this.results.querySelectorAll('a')];
        if (links.length) { e.preventDefault(); links[(links.indexOf(document.activeElement) + 1) % links.length].focus(); }
      }
      if (e.key === 'ArrowUp') {
        const links = [...this.results.querySelectorAll('a')];
        if (links.length) { e.preventDefault(); links[(links.indexOf(document.activeElement) - 1 + links.length) % links.length].focus(); }
      }
    }, { signal });
    document.addEventListener('pointerdown', e => { if (!this.contains(e.target)) this.close(); }, { signal });
    this.input.addEventListener('focus', () => { if (this.results.childElementCount && this.input.value.trim()) this.open(); }, { signal });
  }
  disconnectedCallback() { this.abort?.abort(); this.request?.abort(); clearTimeout(this.timer); super.disconnectedCallback(); }
  close() { this.results.hidden = true; this.input.setAttribute('aria-expanded', 'false'); }
  open() { this.results.hidden = false; this.input.setAttribute('aria-expanded', 'true'); }
  async search() {
    const q = this.input.value.trim();
    if (!q) { this.results.replaceChildren(); this.close(); return; }
    const controller = this.request = new AbortController();
    const url = new URL(this.dataset.endpoint, location.origin);
    url.searchParams.set('q', q);
    url.searchParams.set('resources[type]', 'product');
    url.searchParams.set('resources[limit]', '5');
    url.searchParams.set('resources[options][unavailable_products]', 'last');
    try {
      const response = await fetch(url, { signal: controller.signal });
      if (!response.ok) throw new Error('Search unavailable');
      const data = await response.json();
      if (this.request !== controller) return;
      this.results.replaceChildren();
      for (const product of data.resources.results.products) {
        const a = document.createElement('a'); a.href = product.url; a.className = 'tt-search-result';
        if (product.image) { const img = document.createElement('img'); img.src = product.image; img.alt = ''; img.width = 58; img.height = 58; a.append(img); }
        const span = document.createElement('span'); span.textContent = product.title; a.append(span);
        this.results.append(a);
      }
      if (!this.results.childElementCount) { const p = document.createElement('p'); p.textContent = this.dataset.empty; this.results.append(p); }
      const all = document.createElement('a'); const search = new URL(this.querySelector('form').action); search.searchParams.set('q', q); search.searchParams.set('type', 'product'); all.href = search; all.textContent = this.dataset.all; all.className = 'tt-search-all'; this.results.append(all);
      this.open();
    } catch (e) { if (e.name !== 'AbortError') this.close(); }
  }
}
if (!customElements.get('timber-live-search')) customElements.define('timber-live-search', TimberLiveSearch);

class TimberNavigation extends Component {
 connectedCallback(){
  super.connectedCallback();this.abort=new AbortController();const {signal}=this.abort;
  for(const item of this.querySelectorAll('.tt-nav-item')){
   const button=item.querySelector('button'),panel=item.querySelector('.tt-nav-dropdown');if(!button||!panel)continue;
   const open=()=>{for(const other of this.querySelectorAll('.tt-nav-item'))if(other!==item)this.close(other);button.setAttribute('aria-expanded','true');panel.hidden=false;};
   item.addEventListener('pointerenter',e=>{if(e.pointerType!=='touch')open();},{signal});
   item.addEventListener('pointerleave',()=>{if(item.dataset.ttPinned!=='true'&&!item.contains(document.activeElement))this.close(item);},{signal});
   button.addEventListener('click',e=>{const close=e.detail===0?button.getAttribute('aria-expanded')==='true':item.dataset.ttPinned==='true';if(close)this.close(item);else{open();item.dataset.ttPinned='true';}},{signal});
   item.addEventListener('focusout',e=>{if(!item.contains(e.relatedTarget))this.close(item);},{signal});
   item.addEventListener('keydown',e=>{if(e.key==='Escape'){this.close(item);button.focus();}if(e.key==='ArrowDown'){e.preventDefault();open();panel.querySelector('a')?.focus();}},{signal});
  }
  document.addEventListener('pointerdown',e=>{if(!this.contains(e.target))for(const item of this.querySelectorAll('.tt-nav-item'))this.close(item);},{signal});
 }
 close(item){delete item.dataset.ttPinned;const b=item.querySelector('button'),p=item.querySelector('.tt-nav-dropdown');if(b)b.setAttribute('aria-expanded','false');if(p)p.hidden=true;}
 disconnectedCallback(){this.abort?.abort();super.disconnectedCallback();}
}
if(!customElements.get('timber-navigation'))customElements.define('timber-navigation',TimberNavigation);
